import React, { useState, useEffect } from 'react';
import PushMessageServices from '../../services/PushMessageServices';

const PushStatus = ({ data, page, onSuccess }) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // Set the initial status based on data passed from parent component
    setIsChecked(data === 'Active');
  }, [data]);

  const handleToggle = async () => {
    const newStatus = isChecked ? 'Inactive' : 'Active';

    try {
      // Update the message status using the service
      await PushMessageServices.updateMessage({
        [page === 'message1' ? 'messageStatus1' : 'messageStatus2']: newStatus
      });
      setIsChecked(!isChecked); // Update local state
      onSuccess(newStatus); // Pass new status to parent component
    } catch (error) {
      console.error('Failed to update message status:', error);
    }
  };

  return (
    <div className="check-box">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
      />
    </div>
  );
};

export default PushStatus;
